import { render } from "./WhatDoWheel.vue?vue&type=template&id=bfc25be6&scoped=true"
import script from "./WhatDoWheel.vue?vue&type=script&lang=js"
export * from "./WhatDoWheel.vue?vue&type=script&lang=js"

import "./WhatDoWheel.vue?vue&type=style&index=0&id=bfc25be6&scoped=true&lang=css"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfc25be6"]])

export default __exports__